module.exports = __webpack_public_path__ + "img/checked.536fb010.svg";